<template>
    <van-popup class="web-login-popup" :value="showWebLogin" @click-overlay="clickCancel">
        <div v-if="!showWebLoginWechatCode" class="web-login-step-1">
            <!-- 切换输入框登录方式 -->
            <div class="web-login-title">手机号登录</div>
            <!-- 登录输入框 -->
            <div class="web-login-form">
                <div class="web-login-toggle" @click="clickToggle">{{loginType == 1 ? '验证码登录' : '账号密码登录'}}</div>
                <div class="web-login-line">
                    <input class="web-login-input" placeholder="输入手机号码" @input="checkVerifyLocked" v-model="telNumValue" maxlength="11" type="text">
                </div>
                <div class="web-login-line web-login-line-2 dsp-flex">
                    <input class="web-login-input" v-bind:placeholder="loginType == 1 ? '密码' : '验证码'" v-model="passWordValue" type="password">
                    <button v-if="loginType == 2" class="web-login-verify" @click="clickGetCode">
                        <span v-bind:class="{'gray': verifyLocked}">获取验证码</span>
                    </button>
                </div>
            </div>
            <!-- 登录按钮 -->
            <div class="web-login-btn">
                <button class="button-green web-login-btn-ok" @click="clickLogin">登  录</button>
                <div class="web-login-select" @click="clickAgree">
                    <i class="iconfont " v-bind:class="{'icon-unselected': !agreed, 'icon-selected': agreed}"></i>我已阅读并同意木火通明<span @click="clickAgreeUrl">服务协议</span>和<span @click="clickPrivacyUrl">隐私政策</span>
                </div>
            </div>
            <!-- 第三方登录入口 -->
            <div class="web-third-login">
                <div class="web-third-login-title">第三方账号登录</div>
                <div class="web-third-login-btn">
                    <button class="web-login-wechat" @click="clickWechat"></button>
                    <button class="web-login-qq" @click="clickQQ"></button>
                </div>
            </div>
        </div>
        <div v-else class="web-login-step-2">
            <div class="web-login-title">微信扫码登录</div>
            <div class="web-login-toggle" @click="clickBack">手机号登录</div>
            <div class="web-login-wechat-code">
                <qrcode id='qrImg' tag="img" :options="{size: 200, padding: 20}" :value="CONFIG.getWechatAuthUrl()" ></qrcode>
            </div>
            <div class="web-login-sub-title">请使用微信扫描二维码登录</div>
        </div>
    </van-popup>
</template>

<script>
import { UTILS } from '../../modules/utils';
import { CONFIG } from '../../modules/config';
export default {
    name: 'WebLoginPop',
    computed: {
        showWebLogin() {
            return this.$store.state.weblogin.showWebLogin
        },
        showWebLoginWechatCode() {
            return this.$store.state.weblogin.showWebLoginWechatCode
        }
    },
    data() {
        return {
            CONFIG: CONFIG,
            loginType: 1,
            telNumValue: '',
            passWordValue: '',
            verifyLocked: true,
            agreed: true,
        }
    },
    methods: {
        clickCancel() {
            this.$store.state.weblogin.showWebLogin = false;
        },
        clickToggle() {
            this.loginType = this.loginType == 1 ? 2 : 1;
            this.checkVerifyLocked();
        },
        checkVerifyLocked() {
            if(this.loginType == 2 && this.telNumValue != '') {
                this.verifyLocked = !UTILS.isPoneAvailable(parseInt(this.telNumValue));
            }
        },
        clickGetCode() {
            // 获取二维码按钮被锁定
            if(this.verifyLocked) {
                return;
            }
            var me = this;
            this.$store.dispatch('weblogin/getLoginCode', {
                tel: this.telNumValue,
                type: '1',
                sucCb: function() {
                    me.verifyLocked = true;
                    setTimeout(() => {
                        me.verifyLocked = false;
                    }, 60000);
                }
            })
        },
        clickLogin() {
            // 检验数据是否为空
            if(this.telNumValue == '') {
                this.$toast('请输入手机号码');
                return;
            }
            if(this.passWordValue == '') {
                if(this.loginType == 1) {
                    this.$toast('请输入密码');
                }else {
                    this.$toast('请输入验证码');
                }
                return;
            }
            if(!this.agreed) {
                this.$toast('请先同意服务协议和隐私政策');
                return;
            }
            // 校验数据准确性
            if(!UTILS.isPoneAvailable(parseInt(this.telNumValue))) {
                this.$toast('请输入正确的手机号码');
                return;
            }
            console.log('clickLogin--------', this.telNumValue, this.passWordValue, this.loginType)

            this.$store.dispatch('weblogin/getUserLogin', {
                tel: this.telNumValue,
                password: this.passWordValue,
                type: this.loginType.toString()
            });
        },
        clickWechat() {
            // this.$store.state.weblogin.showWebLoginWechatCode = true; 
            window.location.href = CONFIG.getWechatAuthUrl();
        },
        clickQQ() {
            window.location.href = CONFIG.getQQAuthUrl();
        },
        clickAgree() {
            this.agreed = !this.agreed;
        },
        clickAgreeUrl() {
            window.open(CONFIG.agree_url);
        },
        clickPrivacyUrl() {
            window.open(CONFIG.privacy_url);
        },
        clickBack() {
            this.$store.state.weblogin.showWebLoginWechatCode = false; 
        }
    }
}
</script>